import OnScreenAlert from "./OnScreenAlert";
export default OnScreenAlert;
